// extracted by mini-css-extract-plugin
export var contentBody = "_dd-9";
export var headerImage = "_dd-2";
export var imageButton = "_dd-7";
export var imageButtonIcon = "_dd-8";
export var imageHeader = "_dd-4";
export var imageHeaderText = "_dd-5";
export var imageOverlay = "_dd-3";
export var imageTitle = "_dd-6";
export var imageWrapper = "_dd-1";
export var taskList = "_dd-a";
export var widget = "_dd-0";